import { Autocomplete, Button } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { useToast } from "src/hooks/useToast";
import { useEffect, useState } from "react";
import MultiAutocompleteAsync from "src/components/ui/MultiAutocompleteAsync";
import { getCompanyList, getDivisionList, getStateList } from "src/services/order-api";
import { generateCounterProductReport } from "src/services/reports-api";

const ProductReportFilters = ({
    onCloseModal,
    onSuccess,
}: {
    onCloseModal: () => void;
    onSuccess: () => void
}) => {
    const { toast } = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState<any>(null);
    const [selectedStates, setSelectedStates] = useState<any>([]);
    const [selectedDivisions, setSelectedDivisions] = useState<any>([]);
    const [companyData, setCompanyData] = useState<any>([]);
    const [stateData, setStateData] = useState<any>([]);
    const [divisionData, setDivisionData] = useState<any>([]);
    const [selectedReportType, setSelectedReportType] = useState<any>([]);
    const [selectedModuleType, setSelectedModuleType] = useState<any>([]);

    const fetchDivision = async (value: any) => {
        const payload = {
            company_code: selectedCompany?.code,
            search: value,
        };

        try {
            const res = await getDivisionList(payload);
            setDivisionData(res?.data?.data);
            return res?.data?.data;
        } catch (error) {
            console.log(error);
        }
    }

    const handleReportSubmit = async () => {

        if (!selectedReportType?.id) {
            toast({ description: "Please select report type", variant: "destructive" });
            return;
        }

        if (!selectedCompany?.code) {
            toast({ description: "Please select company", variant: "destructive" });
            return;
        }

        setIsLoading(true);
        const payload = {
            "report_type": selectedReportType?.id,
            "filters": {
                "divisions": selectedDivisions?.map((item: any) => item?.company_divisioncode),
                "states": selectedStates?.map((item: any) => item?.state_code),
            },
            "company_code": selectedCompany?.code,
            "company_name": selectedCompany?.name
        }
        try {
            const response = await generateCounterProductReport(payload);
            console.log(response);
            toast({ description: "Report generation request sent successfully", variant: "default" });
            if (response?.data?.success) {
                onCloseModal();
                onSuccess();
            }
        } catch (error: any) {
            console.log(error);
            toast({ description: error?.response?.data?.message || "Failed to generate report", variant: "destructive" });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!companyData?.length) {
            getCompanyList()
                .then((res) => setCompanyData(res?.data))
                .catch((err) => console.log(err));

        }
        if (!stateData?.length) {
            getStateList()
                .then((res) => setStateData(res?.data?.data))
                .catch((err) => console.log(err));
        }
    }, []);

    console.log("selectedModuleType", selectedModuleType);

    return (
        <div className="flex flex-col gap-y-2 w-[400px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Generate Report</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>
            <div className="flex flex-col gap-y-2 px-2">
                <div className="mb-2">
                    <label className="text-sm font-normal text-[#666666]">Company Name</label>
                    <Autocomplete
                        onSelectionChange={(value: any) => { setSelectedCompany(value) }}
                        placeholder="Select Company"
                        inputClassName="w-full mt-2"
                        suggestionList={companyData || []}
                        displayKey="name"
                        defaultValue={selectedCompany}
                        uniqueKey="code" />
                </div>
                <div className="">
                    <label className="text-sm mb-2 font-normal text-[#666666]">Divisions</label>
                    <MultiAutocompleteAsync
                        placeholder="Divisions"
                        inputClassName="w-full"
                        suggestionList={divisionData || []}
                        displayKey="division_name"
                        uniqueKey="company_divisioncode"
                        defaultValue={selectedDivisions}
                        controlledValue={selectedDivisions}
                        isAsyncQuery={true}
                        asyncListFunction={selectedCompany?.code ? fetchDivision : undefined}
                        onSelectionChange={(value: any, action: any) => {
                            if (action === "remove") {
                                setSelectedDivisions(selectedDivisions.filter((item: any) => item.company_divisioncode !== value.company_divisioncode))
                            } else {
                                setSelectedDivisions([...selectedDivisions, value])
                            }
                        }}
                    />
                </div>
                <div className="mt-0">
                    <label className="text-sm font-normal text-[#666666]">States</label>
                    <MultiAutocompleteAsync
                        placeholder="States"
                        inputClassName="w-full"
                        suggestionList={stateData || []}
                        controlledValue={selectedStates}
                        displayKey="state_name"
                        uniqueKey="state_code"
                        defaultValue={selectedStates}
                        onSelectionChange={(value: any, action: any) => {
                            if (action === "remove") {
                                setSelectedStates(selectedStates.filter((item: any) => item.state_code !== value.state_code))
                            } else {
                                setSelectedStates([...selectedStates, value])
                            }
                        }}
                    />
                </div>
                <div className="mt-0">
                    <label className="text-sm font-normal text-[#666666]">Report Type</label>
                    <Autocomplete
                        placeholder="Report Type"
                        inputClassName="w-full"
                        suggestionList={[{
                            id: "COUNTER_PRODUCT_WITH_SKU",
                            name: "Counter Product with SKU"
                        }, {
                            id: "COUNTER_PRODUCT_WITHOUT_SKU",
                            name: "Counter Product without SKU"
                        }]}
                        displayKey="name"
                        uniqueKey="id"
                        defaultValue={selectedReportType}
                        onSelectionChange={(value: any) => {
                            setSelectedReportType(value)
                        }}
                    />
                </div>
                <div className="mt-0">
                    <label className="text-sm font-normal text-[#666666]">Module Type</label>
                    <Autocomplete
                        placeholder="Module Type"
                        inputClassName="w-full"
                        suggestionList={[{
                            id: "MEDVOL",
                            name: "Medvol"
                        }, {
                            id: "PUC",
                            name: "PUC"
                        }]}
                        displayKey="name"
                        uniqueKey="id"
                        defaultValue={selectedModuleType}
                        onSelectionChange={(value: any) => {
                            setSelectedModuleType(value)
                        }}
                    />
                </div>
            </div>

            <div className="gap-x-2">
                <Button isLoading={isLoading} loaderSize="small" disabled={isLoading} className="text-white w-full bg-[#8051FF] mt-4" onClick={handleReportSubmit}>
                    Submit
                </Button>

            </div>
        </div >
    );
};

export default ProductReportFilters;
